"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var STACK_GAP;
(function (STACK_GAP) {
    STACK_GAP["none"] = "none";
    STACK_GAP["xxs"] = "xxs";
    STACK_GAP["xs"] = "xs";
    STACK_GAP["s"] = "s";
    STACK_GAP["m"] = "m";
    STACK_GAP["l"] = "l";
    STACK_GAP["xl"] = "xl";
    STACK_GAP["xxl"] = "xxl";
    STACK_GAP["xxxl"] = "xxxl";
})(STACK_GAP = exports.STACK_GAP || (exports.STACK_GAP = {}));
var STACK_ALIGN;
(function (STACK_ALIGN) {
    STACK_ALIGN["start"] = "start";
    STACK_ALIGN["center"] = "center";
    STACK_ALIGN["end"] = "end";
    STACK_ALIGN["fill"] = "fill";
})(STACK_ALIGN = exports.STACK_ALIGN || (exports.STACK_ALIGN = {}));
var STACK_DISTRIBUTION;
(function (STACK_DISTRIBUTION) {
    STACK_DISTRIBUTION["between"] = "between";
    STACK_DISTRIBUTION["fill"] = "fill";
    STACK_DISTRIBUTION["lastFill"] = "lastFill";
    STACK_DISTRIBUTION["firstFill"] = "firstFill";
    STACK_DISTRIBUTION["center"] = "center";
    STACK_DISTRIBUTION["around"] = "around";
    STACK_DISTRIBUTION["start"] = "start";
    STACK_DISTRIBUTION["end"] = "end";
})(STACK_DISTRIBUTION = exports.STACK_DISTRIBUTION || (exports.STACK_DISTRIBUTION = {}));
var STACK_DIRECTION;
(function (STACK_DIRECTION) {
    STACK_DIRECTION["row"] = "row";
    STACK_DIRECTION["column"] = "column";
})(STACK_DIRECTION = exports.STACK_DIRECTION || (exports.STACK_DIRECTION = {}));
//# sourceMappingURL=types.js.map